<template>
  <b-container fluid class="mt-3 text-center">
    <b-form>

    <div v-if="this.errorConexion == true" >
            <b-overlay :show="overlayI" variant="light" opacity="0.97" rounded="sm">
                <div class="row justify-content-center ">
                    <div class="col-sm-9 text-center mb-2">
                    <h1 class="style-nissan">Ha ocurrido un error de Conexión.</h1>
                    <p>Vuelve intentar mas tarde.</p>
                        <img src="../assets/error_conexion.png" class="img-fluid" width="250px" height="auto" alt="" />
                    <div>
                        <p>Puedes contactarnos a <span style="color: #172546;"> <b>ClikAuto</b></span> <span style="color: #51AED3;"> <b>Mobility</b></span> 800-022-5425</p>
                    </div>
                    <div>
                        <b-button @click.prevent="regresar()" class="button_bk">REGRESAR</b-button>
                        <p>Error Service autocomcube.</p>
                    </div>

                    </div>
                </div>
            <template #overlay>
                <div class="text-center">
                <img src="../assets/car-2.png" class="img-fluid spinner-grow text-light">
                <h6>Cargando ...</h6>
                </div>
            </template>
            </b-overlay>
    </div>

    <div v-if="this.errorConexion == false" class="row justify-content-md-center">
      <div class="col-sm-9">
        <div>
          <b-card class="fondoCorreo" border-variant="light">
            <img src="../assets/logo-mobility.png" class="img-fluid imagenCorreo" alt="" />
          </b-card>
        </div>

        <div>
          <b-card class="text-center" border-variant="light">
            <h2 class="tituloc">¡Tenemos tus resultados!</h2>
            <br>
            <h5 class="tituloc2">Tienes una suscripción pendiente, continúa desde un dispositivo móvil</h5>
            <p>Revisa la bandeja de tu correo y/o bandeja de spam</p>
          </b-card>
        </div>
        <div>
        <b-card class="text-center" style="background: #51555C; color: #FFFFFF">
            <b-row>
              <div v-if="this.type == 'N'" class="col-md-12">
                <b-col v-for="auto in autos" :key="auto.id">
                  <h5 class="datosC">
                    {{ auto.modelYear }} {{ auto.brandDescription }} {{ auto.trimDesciption }}, {{ auto.bodyType }} {{ auto.gearboxType }}, {{ auto.doors}} PUERTAS, 0 kms
                  </h5>
                </b-col>
              </div>

              <div v-if="this.type == 'U'" class="col-md-12">
                <b-col v-for="auto in autos" :key="auto.id">
                  <h5 class="datosC">
                    {{ auto.modelYear }} {{ auto.brandDescription }} {{ auto.trimDesciption }}, {{ auto.bodyType }} {{ auto.gearboxType }}, {{ auto.doors}} PUERTAS, 0 kms
                  </h5>
                </b-col>
              </div>
            </b-row>
            <b-row class="mt-3">
              <div class="col-md-4">
                <b-col>
                  <h5 class="datosC2" >Fecha de Solicitud: {{this.fechaSolicitud}}</h5>
                </b-col>
              </div>
              <div class="col-md-4">
                <b-col>
                  <h5 class="datosC2" >VIN: {{this.vin}}</h5>
                </b-col>
              </div>
              <div class="col-md-4">
                <b-col>
                  <h5 class="datosC2" >Tipo: {{this.tipoUnidad}}</h5>
                </b-col>
              </div>
            </b-row>
          </b-card>

          <b-card class="text-center mt-1"  style="background: #E6E6E6;">
            <b-row>
              <div class="col-md-4">
                <b-col>
                  <h5 class="datosC3">Tiempo Suscripción</h5>
                  <h3 class="datosC4">{{this.tiempo}}</h3>
                </b-col>
              </div>
              <div class="col-md-4">
                <b-col>
                  <h5 class="datosC3">Suscripción Mensual</h5>
                  <h3 class="datosC4">${{this.costoSus}}</h3>
                </b-col>
              </div>
              <div class="col-md-4">
                <b-col>
                  <h5 class="datosC3">Entidad Emplacamiento</h5>
                  <h3 class="datosC4">{{this.valorEntidad}}</h3>
                </b-col>
              </div>
            </b-row>
          </b-card>
        </div>

        <div>
          <b-card class="text-center" border-variant="light">
            <b-row class="justify-content-md-center">
                <p class="oferta">Oferta válida hasta {{this.FechaV}}</p>
                <p class="datosC5">¡ Termina ahora tu solicitud !</p>
                <b-button class="button_sc mb-3" @click.prevent="validarDispositivo()">SOLICITAR SUSCRIPCIÓN</b-button>
            </b-row>
              <div class="mt-5 mb-3 text-center">
                  <b-img src="../assets/logo_clikautomobility.png" style="width: 160px;" fluid></b-img>
              </div>
            <h6 class="datosC7">Para dudas en tu proceso recuerda contactarnos en cualquier momento al teléfono: 800-022-5425 o vía correo electrónico en atencion@clikautomobility.com de Lunes a Viernes de 8 am a 8 pm o Sábado de 9 am a 5 pm.</h6>
          <!-- <b-button class="m-3" @click.prevent="mail()" variant="danger" >Mail</b-button> -->
          </b-card>
        </div>
          <b-modal ref="modalNoContinuar"  size="sm" hide-footer>
            <template #modal-title>
              <h5 >Continuar Solicitud</h5>
            </template>
              <div class="d-block"><h6>Tu solicitud debe continuar desde un dispositivo móvil</h6></div>
              <b-button @click.prevent="salir()" block class="button_movil mb-2 mt-4">¡CONTINUAR!</b-button>
          </b-modal>
      </div>
    </div>
    </b-form>
  </b-container>
</template>

<script>
export default {
    name:"Correo",

    data() {
      return {
          autos: [],
          costoSus: sessionStorage.getItem("valorSuscripcion"),
          tiempo: sessionStorage.getItem("tiempoSuscripcion"),
          deposito: 2400,
          valorEntidad: sessionStorage.getItem("emplacamiento"),
          vin: sessionStorage.getItem("vinUnidad"),
          type: sessionStorage.getItem("typeUnidad"),
          tipoUnidad: sessionStorage.getItem("tipoAutoP"),
          FechaV: sessionStorage.getItem("fechaPromo"),
          fechaSolicitud: sessionStorage.getItem("fechaVigencia"),

          errorConexion: false,
          overlayI:false,
      }
    },

    methods: {

    iframeGoVirtual(){
        let message = { height: document.body.scrollHeight+50, width: document.body.scrollWidth }; 

        // window.top refers to parent window
        window.top.postMessage(message, "*");
        console.log('iFrame Go virtual -->',message);
    },

    clearTimeout() {
        if (this.timeout) {
          clearTimeout(this.timeout)
          this.timeout = null
        }
    },

    setTimeout(callback) {
        this.clearTimeout()
        this.timeout = setTimeout(() => {
          this.clearTimeout()
          callback()
        }, 5000);
    },
    cargarInfoVehiculo(){

        if( this.type == 'U'){
            this.autosSeminuevos();
        } else if( this.type == 'N'){
            this.autosNuevos();
        }
      },

      autosNuevos(){
                //axios.get("https://pruebas.autocomcube.mx/ab/api/newstock", { //QA
                axios.get("https://autocomcube.mx/ab/api/newstock", { //PRO        
                headers: {
                  Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                  'Content-Type': 'application/json',
                },
                params: {vin: this.vin},
              }).then((response) => {
                this.autos = response.data.newstock;
              }).catch(error => {
                  this.errorConexion = true;
                  this.overlayI = true;
                  this.setTimeout(() => {
                  this.overlayI = false;});
                  console.log('Error de API Inventario Nuevos --> ',error);
              });
      },

      autosSeminuevos(){
          // console.log('Seminuevo');
                //axios.get("https://pruebas.autocomcube.mx/ab/api/usedstock", { //QA
                axios.get("https://autocomcube.mx/ab/api/usedstock", { //PRO        
                headers: {
                  Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                  'Content-Type': 'application/json',
                },
                params: {vin: this.vin,},
              }).then((response) => {
                this.autos = response.data.usedstock;
              }).catch(error => {
                this.errorConexion = true;
                this.overlayI = true;
                this.setTimeout(() => {
                this.overlayI = false;});
                console.log('Error de API Inventario SemiNuevo --> ',error);
            });
      },

        formatPrice(value) {
            let val = (value/1).toFixed(0).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        salir(){
          sessionStorage.clear();
          window.history.go(-3);
        },

        regresar(){
          window.history.go(-3);
        },
        validarDispositivo(){
                if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                  //window.open("https://onboarding-dev.latinid-cloud.com.mx/MobilityWeb/#/resume/applicant/"+sessionStorage.getItem("UUID58"));
                  //window.open("https://clikautofinance.creditcheck.mx:9445/MobilityWeb/#/resume/applicant/"+sessionStorage.getItem("UUID58"));
                  window.open("https://clikautofinance.creditcheck.mx:9445/MobilityWeb/#/resume/applicant/"+sessionStorage.getItem("UUID58"));
                  sessionStorage.clear();
                  window.history.go(-3);
          } else {
                this.$refs['modalNoContinuar'].show();
                console.log('UUID ---> ',sessionStorage.getItem("UUID58"));
            }
        },
    },

  created() {
    this.cargarInfoVehiculo();
    this.iframeGoVirtual();
   },
}

</script>

<style>
.imagen_autocom {
  height:auto;
}

.input_c{
     border: 1px solid #FDFEFE;
     width: 10px;
     height: 10px;
}


@media only screen and (max-width: 1028px){
  .imagen_autocom {
     width: 150px;
 }

}
</style>